import { createRouter, createWebHistory, RouteRecordRaw, createWebHashHistory } from 'vue-router'
declare global {
  interface Window {
    _hmt: any[]
  }
}

const routes: Array<RouteRecordRaw> = [
  {
    path: '/',
    name: '前台首页',
    component: () => import('@/views/front/index.vue'),
    redirect: '/index',
    children: [
      {
        path: '/index',
        name: '前台首页',
        component: () => import('@/views/front/indexTheme.vue')
      },

      {
        path: '/go',
        name: 'go',
        component: () => import('@/views/front/news/go.vue')
      },

      {
        path: '/front/news/searchServiceHelp',
        name: 'searchServiceHelp',
        component: () => import('@/views/front/news/searchServiceHelp.vue')
      },

      //标准检索
      {
        path: '/front/standardsearch/standardSeniorSearch',
        name: '高级检索',
        component: () => import('@/views/front/standardsearch/standardSeniorSearch.vue')
      },

      {
        path: '/front/standardsearch/standardBusiness',
        name: '企业标准自我声明公开信息检索',
        component: () => import('@/views/front/standardsearch/standardBusiness.vue')
      },

      {
        path: '/front/standardsearch/standardBusinessDetail',
        name: '企业标准自我声明公开信息检索详情',
        component: () => import('@/views/front/standardsearch/standardBusinessDetail.vue')
      },

      {
        path: '/front/standardsearch/standardTeam',
        name: '团体标准自我声明公开信息检索',
        component: () => import('@/views/front/standardsearch/standardTeam.vue')
      },

      {
        path: '/front/standardsearch/standardTeamDetail',
        name: '团体标准自我声明公开信息检索详情',
        component: () => import('@/views/front/standardsearch/standardTeamDetail.vue')
      },

      {
        path: '/front/standardsearch/standardShanghaiBusiness',
        name: '上海市地方标准',
        component: () => import('@/views/front/standardsearch/standardShanghaiBusiness.vue')
      },



      {
        path: '/front/standardsearch/standardCommonSearch',
        name: '标准检索',
        component: () => import('@/views/front/standardsearch/standardCommonSearch.vue')
      },

      {
        path: '/front/standardsearch/standardSearchResult',
        name: '标准检索结果',
        component: () => import('@/views/front/standardsearch/standardSearchResult.vue')
      },

      {
        path: '/front/standardsearch/standardSearchResultDetail',
        name: '搜索详情',
        component: () => import('@/views/front/standardsearch/standardSearchResultDetail.vue')
      },

      {
        path: '/front/standardsearch/standardSearchResultDetail2',
        name: '搜索详情2',
        component: () => import('@/views/front/standardsearch/standardSearchResultDetail2.vue'),
      },

      //专题检索
      {
        path: '/front/topicsearch/specialSubjectSearch',
        name: '专题检索',
        component: () => import('@/views/front/topicsearch/specialSubjectSearch.vue')
      },

      {
        path: '/front/topicsearch/standardLogistics',
        name: '物流标准专题课',
        component: () => import('@/views/front/topicsearch/standardLogistics.vue')
      },

      {
        path: '/front/topicsearch/topicCityRefine',
        name: '城市精细化管理',
        component: () => import('@/views/front/topicsearch/topicCityRefine.vue')
      },
      {
        path: '/front/topicsearch/topicCityRefineDetail',
        name: '城市精细化管理详情',
        component: () => import('@/views/front/topicsearch/topicCityRefineDetail.vue')
      },

      {
        path: '/front/topicsearch/topicFoodSafety',
        name: '食品安全专题库',
        component: () => import('@/views/front/topicsearch/topicFoodSafety.vue')
      },

      {
        path: '/front/topicsearch/businessstdTest',
        name: 'businessstdTest',
        component: () => import('@/views/front/topicsearch/businessstdTest.vue')
      },



      {
        path: '/front/topicsearch/businessstdIndex',
        name: '商务诚信专题库',
        component: () => import('@/views/front/topicsearch/businessstdIndex.vue'),
        redirect: '/front/topicsearch/businessstdIndexContent', // 关键：添加默认重定向
        children: [  // 添加子路由

          {
            path: '/front/topicsearch/businessstdIndexContent',
            name: '网站首页',
            component: () => import('@/views/front/topicsearch/businessstdIndexContent.vue')
          },

          {
            path: '/front/topicsearch/businessstdTitleList',
            name: '重要标准s5',
            component: () => import('@/views/front/topicsearch/businessstdTitleList.vue'),
          },

          {
            path: '/front/topicsearch/businessstdTitleDetail',
            name: '重要标准s5详情',
            component: () => import('@/views/front/topicsearch/businessstdTitleDetail.vue'),
          },

          {
            path: '/front/topicsearch/businessstdTable',
            name: '商务诚信表格',
            component: () => import('@/views/front/topicsearch/businessstdTable.vue')
          },

        ]
      },

      //信息发布 
      {
        path: '/front/inforelease/infoRelease',
        name: '最新标准发布信息',
        component: () => import('@/views/front/inforelease/infoRelease.vue')
      },
      {
        path: '/front/inforelease/infoImplementation',
        name: '即将实施标准',
        component: () => import('@/views/front/inforelease/infoImplementation.vue')
      },
      {
        path: '/front/inforelease/infoObsolete',
        name: '即将作废标准',
        component: () => import('@/views/front/inforelease/infoObsolete.vue')
      },
      {
        path: '/front/inforelease/infoWorkUpdate',
        name: '工作动态',
        component: () => import('@/views/front/inforelease/infoWorkUpdate.vue')
      },

      //国际合作
      {
        path: '/front/international/internationAstm',
        name: 'ASTM专栏',
        component: () => import('@/views/front/international/internationAstm.vue')
      },

      {
        path: '/front/international/internationAstmStandardSearch',
        name: 'ASTM标准查询',
        component: () => import('@/views/front/international/internationAstmStandardSearch.vue')
      },

      {
        path: '/front/international/internationAstmInfo',
        name: 'ASTM专栏简介',
        component: () => import('@/views/front/international/internationAstmInfo.vue')
      },

      {
        path: '/front/international/internationAstmGreeting',
        name: 'ASTM专栏贺词',
        component: () => import('@/views/front/international/internationAstmGreeting.vue')
      },




      {
        path: '/front/international/internationBsi',
        name: 'BSI专栏',
        component: () => import('@/views/front/international/internationBsi.vue')
      },


      {
        path: '/front/international/internationAbroadIssue',
        name: '国外原版出版物',
        component: () => import('@/views/front/international/internationAbroadIssue.vue')
      },

      //服务引导
      {
        path: '/front/serviceguide/serviceCollectionType',
        name: '馆藏品种',
        component: () => import('@/views/front/serviceguide/serviceCollectionType.vue')
      },

      {
        path: '/front/serviceguide/serviceMajorProduct',
        name: '专业产品',
        component: () => import('@/views/front/serviceguide/serviceMajorProduct.vue')
      },

      {
        path: '/front/serviceguide/serviceUsAbout',
        name: '关于我们',
        component: () => import('@/views/front/serviceguide/serviceUsAbout.vue')
      },

      //个人中心
      {
        path: '/front/personalcenter/tLogin',
        name: '登录',
        component: () => import('@/views/front/personalcenter/tLogin.vue')
      },

      {
        path: '/front/personalcenter/tRegisterHint',
        name: '注册信息',
        component: () => import('@/views/front/personalcenter/tRegisterHint.vue')
      },

      {
        path: '/front/personalcenter/tRegister',
        name: '注册',
        component: () => import('@/views/front/personalcenter/tRegister.vue')
      },

      {
        path: '/front/personalcenter/tRegister',
        name: '注册',
        component: () => import('@/views/front/personalcenter/tRegister.vue')
      },

      {
        path: '/front/personalcenter/tRegisterSuccess',
        name: '注册成功',
        component: () => import('@/views/front/personalcenter/tRegisterSuccess.vue')
      },

      //凡是带有2的都是有副本，跟新时候，需要同步两个界面
      // {
      //   path: '/front/personalcenter/tPersonnalMyInstallHelp2',
      //   name: '安装帮助2',
      //   component: () => import('@/views/front/personalcenter/tPersonnalMyInstallHelp2.vue')
      // },


      {
        path: '/front/personalcenter/tPersonnalInstallHelp',
        name: '安装帮助free',
        component: () => import('@/views/front/personalcenter/tPersonnalInstallHelp.vue')
      },


      {
        path: '/front/personalcenter/tPersonnalInstallHelpGuide',
        name: '安装帮助freeguide',
        component: () => import('@/views/front/personalcenter/tPersonnalInstallHelpGuide.vue')
      },



      // {
      //   path: '/front/personalcenter/tPersonalCenter',
      //   name: '个人中心',
      //   component: () => import('@/views/front/personalcenter/tPersonalCenter.vue')
      // },

      {
        path: '/front/personalcenter/tPersonalCenter',
        name: '个人中心',
        component: () => import('@/views/front/personalcenter/tPersonalCenter.vue'),
        redirect: '/front/personalcenter/tPersonalCenterAccount', // 关键：添加默认重定向
        children: [  // 添加子路由

          {
            path: '/front/personalcenter/tPersonalCenterAccount',
            name: '我的账户',
            component: () => import('@/views/front/personalcenter/tPersonalCenterAccount.vue')
          },

          {
            path: '/front/personalcenter/tPersonalOrder',
            name: '我的订单',
            component: () => import('@/views/front/personalcenter/tPersonalOrder.vue'),
          },
          {
            path: '/front/personalcenter/tPersonalOrderDetail',
            name: '我的订单详情',
            component: () => import('@/views/front/personalcenter/tPersonalOrderDetail.vue'),
          },

          {
            path: '/front/personalcenter/tPersonalOrderPay',
            name: '我的订单支付',
            component: () => import('@/views/front/personalcenter/tPersonalOrderPay.vue'),
          },

          {
            path: '/front/personalcenter/tPersonalUpdatePassword',
            name: '修改密码',
            component: () => import('@/views/front/personalcenter/tPersonalUpdatePassword.vue')
          },
          {
            path: '/front/personalcenter/tPersonnalMyAttention',
            name: '我的关注',
            component: () => import('@/views/front/personalcenter/tPersonnalMyAttention.vue')
          },
          {
            path: '/front/personalcenter/tPersonnalMyAddCart',
            name: '添加购物车',
            component: () => import('@/views/front/personalcenter/tPersonnalMyAddCart.vue')
          },
          {
            path: '/front/personalcenter/tPersonnalMyCart',
            name: '购物车',
            component: () => import('@/views/front/personalcenter/tPersonnalMyCart.vue')
          },

          // 普通购物车、普通订单确认：这个是普通用户特有的，管理员没有。管理员有：购车，订单没有确认，直接提交即可。

          {
            path: '/front/personalcenter/tPersonnalShoppingCart',
            name: '普通购物车',
            component: () => import('@/views/front/personalcenter/tPersonnalShoppingCart.vue')
          },

          {
            path: '/front/personalcenter/tPersonnalShoppingConfirm',
            name: '普通订单确认',
            component: () => import('@/views/front/personalcenter/tPersonnalShoppingConfirm.vue')
          },

          {
            path: '/front/personalcenter/tPersonnalMyNews',
            name: '我的查新',
            component: () => import('@/views/front/personalcenter/tPersonnalMyNews.vue')
          },

          {
            path: '/front/personalcenter/tPersonnalMyNewsDt',
            name: '我的查新详情Dt',
            component: () => import('@/views/front/personalcenter/tPersonnalMyNewsDt.vue')
          },
          {
            path: '/front/personalcenter/tPersonnalMyNewsUp',
            name: '我的查新更新Up',
            component: () => import('@/views/front/personalcenter/tPersonnalMyNewsUp.vue')
          },
          {
            path: '/front/personalcenter/tPersonnalMyNewsOnDt',
            name: '我的查新详细OnDt',
            component: () => import('@/views/front/personalcenter/tPersonnalMyNewsOnDt.vue')
          },
          {
            path: '/front/personalcenter/tPersonnalMyNewsOnUp',
            name: '我的查新更新OnUp',
            component: () => import('@/views/front/personalcenter/tPersonnalMyNewsOnUp.vue')
          },


          {
            path: '/front/personalcenter/tPersonnalElectron',
            name: '电子杂志',
            component: () => import('@/views/front/personalcenter/tPersonnalElectron.vue')
          },
          {
            path: '/front/personalcenter/tPersonnalMyRegister',
            name: '注册信息2',
            component: () => import('@/views/front/personalcenter/tPersonnalMyRegister.vue') // 复用MyNews组件
          },
          {
            path: '/front/personalcenter/tPersonnalMyInstallHelp',
            name: '安装帮助',
            component: () => import('@/views/front/personalcenter/tPersonnalMyInstallHelp.vue') // 复用MyNews组件
          },

          {
            path: '/front/personalcenter/tPersonnalMyInstallHelpPdf',
            name: '安装帮助PDF',
            component: () => import('@/views/front/personalcenter/tPersonnalMyInstallHelpPdf.vue')
          },

          {
            path: '/front/personalcenter/tPersonnalMyInstallHelpGuide',
            name: '安装帮助指南',
            component: () => import('@/views/front/personalcenter/tPersonnalMyInstallHelpGuide.vue') // 复用MyNews组件
          },

          //9.12新增的，会员两个页面
          {
            path: '/front/personalcenter/elereadroomAddPersonInfo',
            name: 'elereadroom新增页面',
            component: () => import('@/views/front/personalcenter/elereadroomAddPersonInfo.vue')
          },

          {
            path: '/front/personalcenter/elereadroomShoppingConfirm',
            name: 'elereadroom购物确认',
            component: () => import('@/views/front/personalcenter/elereadroomShoppingConfirm.vue')
          },
        ]
      },

      //新增的三个模块
      {
        path: '/front/news/knowCorpus',
        name: '标准术语语料库',
        component: () => import('@/views/front/news/knowCorpus.vue')
      },

      {
        path: '/front/news/knowCorpusSenior',
        name: '标准术语语料库高级高级检索',
        component: () => import('@/views/front/news/knowCorpusSenior.vue')
      },

      {
        path: '/front/news/knowGraph',
        name: '标准知识图谱',
        component: () => import('@/views/front/news/knowGraph.vue')
      },

      {
        path: '/front/news/knowGraphList',
        name: '标准知识图谱列表',
        component: () => import('@/views/front/news/knowGraphList.vue')
      },

      {
        path: '/front/news/knowGraphTerm',
        name: '标准术语语料库搜索',
        component: () => import('@/views/front/news/knowGraphTerm.vue')
      },

      {
        path: '/front/news/knowGraphTermDetail',
        name: '标准术语元素的概念说明',
        component: () => import('@/views/front/news/knowGraphTermDetail.vue')
      },

      {
        path: '/front/news/knowGraphSenior',
        name: '标准术语语料库高级搜索',
        component: () => import('@/views/front/news/knowGraphSenior.vue')
      },

      // {
      //   path: '/front/news/xmlDocumentRead',
      //   name: 'XML文件阅读器',
      //   component: () => import('@/views/front/news/xmlDocumentRead.vue')
      // },

      {
        path: '/front/news/xmlDocumentRead2',
        name: 'XML文件阅读器2',
        component: () => import('@/views/front/news/xmlDocumentRead2.vue')
      },

      {
        path: '/front/news/xmlDocumentRead3',
        name: 'XML文件阅读器3',
        component: () => import('@/views/front/news/xmlDocumentRead3.vue')
      },

      {
        path: '/front/news/xmlDocumentCompare1',
        name: 'XML文件对比1',
        component: () => import('@/views/front/news/xmlDocumentCompare1.vue')
      },

      {
        path: '/front/news/xmlDocumentCompare2',
        name: 'XML文件对比2',
        component: () => import('@/views/front/news/xmlDocumentCompare2.vue')
      },

      {
        path: '/front/news/xmlDocumentCompare3',
        name: 'XML文件对比3',
        component: () => import('@/views/front/news/xmlDocumentCompare3.vue')
      },

      {
        path: '/front/news/xmlDocumentCompare',
        name: 'XML文件对比',
        component: () => import('@/views/front/news/xmlDocumentCompare.vue')
      },

      {
        path: '/front/news/ofdDocumentRead',
        name: 'OFD文件阅读器',
        component: () => import('@/views/front/news/ofdDocumentRead.vue')
      },

      {
        path: '/front/news/ofdDocumentReadStandard',
        name: '强制国准OFD文件阅读器',
        component: () => import('@/views/front/news/ofdDocumentReadStandard.vue')
      },
      

      {
        path: '/front/news/ofdDocumentReadBusiness',
        name: 'OFD文件阅读器ofdDocumentReadBusiness',
        component: () => import('@/views/front/news/ofdDocumentReadBusiness.vue')
      },

      {
        path: '/front/news/ofdDocumentShangHaiRead',
        name: 'ShangHaiOFD文件阅读器',
        component: () => import('@/views/front/news/ofdDocumentShangHaiRead.vue')
      },

      {
        path: '/front/news/descTest',
        name: '加解密测试demo',
        component: () => import('@/views/front/news/descTest.vue')
      },

      {
        path: '/front/news/graphDetails',
        name: '知识图谱详情',
        component: () => import('@/views/front/news/graphDetails.vue')
      },


      //忘记密码、忘记密码的重置密码
      {
        path: '/front/personalcenter/tRegisterForget',
        name: '忘记密码',
        component: () => import('@/views/front/personalcenter/tRegisterForget.vue')
      },

      {
        path: '/front/personalcenter/tRegisterForgetUpdate',
        name: '忘记密码&重置密码',
        component: () => import('@/views/front/personalcenter/tRegisterForgetUpdate.vue')
      },

      {
        path: '/front/personalcenter/tRegisterActivate',
        name: '注册激活',
        component: () => import('@/views/front/personalcenter/tRegisterActivate.vue')
      },
    ]
  },
  {
    // 404页面配置
    path: "/:pathMatch(.*)",
    name: "NotFound",
    component: () => import("@/views/error/NotFound.vue"),
  }

]

const router = createRouter({
  //history: createWebHashHistory(),  // 改为 Hash 模式
  history: createWebHistory(process.env.BASE_URL),
  routes
})


// ... 你现有的路由配置保持不变

// 百度统计路由跟踪
router.afterEach((to, from) => {
  // 延迟确保页面已渲染
  setTimeout(() => {
    // 只在 _hmt 存在时发送统计，移除生产环境判断
    if (process.env.NODE_ENV === 'production' && window._hmt && to.fullPath) {
      try {
        window._hmt.push(['_trackPageview', to.fullPath])
        console.log(`百度统计: 跟踪 ${to.fullPath}`)
      } catch (error) {
        console.error('百度统计跟踪失败:', error)
      }
    } else {
      console.warn('百度统计未加载，无法跟踪页面访问')
    }
  }, 100)
})

export default router